const STORAGE_KEY = "vc.sessionToken";

export function rememberSessionToken(token: string): string {
  if (!token) return "";
  try {
    window.sessionStorage.setItem(STORAGE_KEY, token);
  } catch {
    // Storage can be unavailable in hardened embedded browsers; keep using the token in memory.
  }
  return token;
}

function readStoredToken(): string {
  try {
    return window.sessionStorage.getItem(STORAGE_KEY) ?? "";
  } catch {
    return "";
  }
}

// Officer (traffic/field) session token. The admin console does NOT use this token: it signs in
// with the administrator password and keeps its own session (services/adminSession.ts).
export function readSessionToken(search?: URLSearchParams): string {
  const fromUrl = search?.get("token") ?? "";
  if (fromUrl) return rememberSessionToken(fromUrl);
  return readStoredToken();
}
